<template>
  <v-app>
    <app-notifications></app-notifications>
    <header-comp v-if="isAuth"></header-comp>
    <side-bar v-if="isAuth"></side-bar>
    <!-- <dialog-loading v-if=""></dialog-loading> -->
    <v-main class="whitegrey">
      <router-view :class="isAuth? '' : $route.name == 'OrdersTvPanel'? '' : 'red darken-3'"></router-view>
    </v-main>
   <!-- <bottom-bar></bottom-bar>  -->
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Api from '@/api'

export default {
  name: "App",
  components: {
    AppNotifications: () =>import('./components/notification/Notifications'),
    HeaderComp: () => import("@/components/shared/_header_01.vue"),
    SideBar: () => import("@/components/shared/_drawer_01.vue"),
    //BottomBar: () => import("@/components/shared/_bottom_01.vue")
  },
  data(){
    return {
      interval: null,
    }
  },
  methods: {
    getProfile(){
      Api.User.profile().then(r=> r.data).then(d=> {
        // console.log({d});
        this.$store.dispatch("User/setCurrentUser", d);
      })
    },
    ...mapActions({
      setActiveDepotId: 'App/setActiveDepotId',
      indexStatus: 'Status/index',
      countOrders: 'Order/countOrders',
    })
  },
  beforeDestroy(){
    clearInterval(this.interval)
  },
  computed: {
    authReady() {
      return !this.$auth0.isLoading;
    },
    isAuth() {
      return this.$auth0.isAuthenticated;
    },
    ...mapState({
      activeDepotId: state => state.App.activeDepotId,
    })
  },
  mounted () {
    this.$dayjs.locale('pt-BR');
    if (this.$auth0.isAuthenticated){
      this.getProfile()
    } else {
      // this.$router.push('/login')
    }
  },
  watch: {
    isAuth(nv){
      if (nv){
        this.$store.dispatch("User/setCurrentUser", this.$auth0.user);
        this.getProfile()
      } else {
          // this.$router.push('/login')

      }
    },
    authReady(val) {
      if (val) {
        // console.log("comit");
        // console.log(this.$auth.user())
        if (this.$auth0.isAuthenticated){
          this.$store.dispatch("User/setCurrentUser", this.$auth0.user);
          this.getProfile()
        }
        // this.indexStatus()
        // this.setProfile();
      } else {
        if (!this.$auth0.isAuthenticated){
          // this.$router.push('/login')
        }
      }
    },
    activeDepotId(nv,ov) {
      clearInterval(this.interval)
      if (nv){
        this.setUpdateCountOrders()
      } else if (nv == false){
    
      }
    }
  }
};
</script>
<style lang="scss">
  @import './assets/styles/main.scss';

// .v-btn {
//   text-transform: none !important;
// }

.v-dialog{
  border-radius: 20px !important;
}

.swal2-styled.swal2-confirm {
  background-color: rgba(63, 167, 255, 0.15) !important;
  font-size: 0.85rem !important;
  line-height: 2rem;
  color: black !important;
  font-weight: 500 !important;
  letter-spacing: 0.05em !important;
  font-family: "Poppins", sans-serif !important;
  text-transform: uppercase !important;
  padding: 1px 46px !important;
}

.swal2-styled.swal2-cancel {
  background-color: rgba(232, 38, 30, 0.3) !important;
  font-size: 0.85rem !important;
  line-height: 2rem !important;
  color: black !important;
  font-weight: 500 !important;
  letter-spacing: 0.05em !important;
  font-family: "Poppins", sans-serif !important;
  text-transform: uppercase !important;
  padding: 1px 18px !important;
}

.swal2-icon.swal2-warning {
  margin: 18px 18px !important;
}

.swal2-title {
  font-size: 1em !important;
  font-family: "Poppins", sans-serif !important;
}


.theme--light.v-text-field.v-input--is-disabled .v-input__slot::before {
  color: rgb(10, 10, 10) !important;
  border-image: repeating-linear-gradient(to right, rgb(10, 10, 10) 0px, rgb(10, 10, 10) 2px) 1 repeat !important;
}

[class$="-disabled"],
[class*="-disabled "] fieldset {
  /* border-color: #000 !important; */
  /* line-height: 10px !important; */
  color: #eee !important; 
  /* font-size: 120px !important; */
}

[class$="-disabled"],
[class*="-disabled "] input{
  border-style: none;
  color: #000 !important; 
  /* font-size: 18px; */
}

[class$="-disabled"],
[class*="-disabled "] label{
  color: rgb(88, 88, 88) !important; 
}

.theme--light.v-input--is-disabled textarea {
  color: black !important;
}


::v-deep.rounder.v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot {
  border: solid 1px #a5a5a5;
}

</style>

